<div class="container-fluid ">
    <div class="row">
        <div class="col-sm-12">
            <header>
                <div class="row bg-white border-bottom">
                    <div class="col-sm-12">
                        <div class="container">
                            <div class="row g-0" id="topbar">
                                <div class="col-sm-6 d-flex align-items-center">
                                    <span class="email"><i class="far fa-envelope me-2"></i>
                                        info@ncpyouths.com </span>
                                </div>
                                <div class="col-sm-6 text-end">
                                    <!-- Language :
                                    <div class="btn-group ms-2" role="group" aria-label="Basic radio toggle button group">
                                        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked>
                                        <label class="btn btn-outline-secondary" for="btnradio1">English</label>
                                        <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                                        <label class="btn btn-outline-secondary" for="btnradio2">Marathi</label>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row bg-white shadow-sm ">
                    <div class="col-sm-12">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">
                                    <nav class="navbar navbar-expand-lg navbar-light bg-white p-0">
                                        <a class="navbar-brand" routerLink="/home">
                                            <img src="assets/images/logos/ncp-new-logo.svg" alt="NCP Youth Congress" class="logo" />
                                        </a>
                                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                            <span class="navbar-toggler-icon"></span>
                                        </button>
                                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                            <div class="d-flex ms-auto">
                                                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                                                    <li class="nav-item">
                                                        <a class="nav-link" aria-current="page" routerLink="/home"  routerLinkActive="Active">
                                                            <i class="fas fa-home"></i>
                                                        </a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link">About</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" routerLink="/events" routerLinkActive="Active">Events</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link">Team</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link">Contact</a>
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link">Donate Now</a>
                                                        <!-- donate -->
                                                    </li>
                                                    <li class="nav-item">
                                                        <a class="nav-link" routerLink="/login">Login</a>
                                                    </li>
                                                    <!-- <li class="nav-item">
                                                        <div class="dropdown">
                                                            <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                {{(language == 'English'?'header.english' : 'header.marathi') | translate}}
                                                            </button>
                                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                               <li><a class="dropdown-item mb-1" type="button" (click)="changeLanguage('English')"
                                                                        [class.active]="language == 'English'"> {{'header.english' | translate}}</a></li>
                                                                <li><a class="dropdown-item" type="button" (click)="changeLanguage('Marathi')"
                                                                        [class.active]="language == 'Marathi'"> {{'header.marathi' | translate}}</a></li>
                                                            </ul>
                                                        </div>
                                                    </li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    </div>
</div>